import React from "react";
import { Card, Col, Row, Statistic } from "antd";

const FuelPriceStats = ({ stats }) => {
    return (
        <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={5}>
                <Card size="small">
                    <Statistic title="总记录" value={stats.total} />
                </Card>
            </Col>
            <Col span={5}>
                <Card size="small">
                    <Statistic title="草稿" value={stats.draft} valueStyle={{ color: "#8c8c8c" }} />
                </Card>
            </Col>
            <Col span={5}>
                <Card size="small">
                    <Statistic title="待确认" value={stats.pending} valueStyle={{ color: "#1890ff" }} />
                </Card>
            </Col>
            <Col span={5}>
                <Card size="small">
                    <Statistic title="已确认" value={stats.confirmed} valueStyle={{ color: "#52c41a" }} />
                </Card>
            </Col>
            <Col span={4}>
                <Card size="small">
                    <Statistic title="异常" value={stats.disputed} valueStyle={{ color: "#f5222d" }} />
                </Card>
            </Col>
        </Row>
    );
};

export default FuelPriceStats;
